<header class="container">
  <div class="row py-4">
    <p-brand class="col-6"></p-brand>

    <div
      *ngIf="isUserAuthenticated && currentUser && isUserInfoDisplayed"
      class="col-3 d-flex justify-content-end infos-credits"
    >
      <div *ngIf="solde">
        <span>
          <span class="text-black infos-credits__label">Crédits :</span>
        </span>
        <strong
          [ngClass]="{ 'text-warning': solde > 0, 'text-danger': solde < 0 }"
          class="infos-credits__solde"
        >
          {{ solde }}
        </strong>
      </div>
    </div>

    <div
      *ngIf="isUserAuthenticated && currentUser && isUserInfoDisplayed"
      class="col-3 d-flex flex-column infos-user border-start border-2 border-primary"
    >
      <p-account-menu [currentUser]="currentUser" class="mb-2">
      </p-account-menu>
      <span class="infos-user__name">
        {{ currentUser.prenom }} {{ currentUser.nom }}
      </span>

      <span class="infos-user__office"> Code client {{ currentCrpcen }} </span>

      <a (click)="signOut()">Déconnexion</a>
    </div>
  </div>
</header>

<p-main-menu
  [currentUser]="currentUser"
  [isUserAuthenticated]="isUserAuthenticated"
  [isUserInfoDisplayed]="isUserInfoDisplayed"
></p-main-menu>
